<template>
  <div class="page-logout com_bg2">
    <div id="wrapper1">
      <img
        src="@/assets/common/img/with-kaunet_logo-logout.png"
        alt="ウィズカウネット エージェントポータル"
        class="with-kaunet_logo-logout"
        style="margin-top: 0"
      />

      <h2 class="com_mgb45 com_mgt100 com_fs26 com_medium1 com_center1">
        ログアウトしました
      </h2>

      <router-link to="/login" class="com_button1">ログインページ</router-link>
      <p class="com_copyright1 com_mgt100">© 2025 Kaunet</p>
    </div>
  </div>
</template>

<style scoped>
.page-logout #wrapper1 {
  /* グレー背景のまま、全体を少し下げる */
  padding-top: 30px; /* ←好きな高さに調整 */
}
</style>
